(function () {
  const SUPABASE_URL = 'https://zhadhjxsnmbnqdpiuiyw.supabase.co';
  const SUPABASE_KEY = 'sb_publishable_99An6wmeGvA4fxS906_I_w_fe0t3DfM';

  const supabase = window.supabase.createClient(SUPABASE_URL, SUPABASE_KEY);

  document.querySelectorAll('.cud-public-review-app').forEach(function (app) {
    loadPublicReviews(app);
  });

  async function loadPublicReviews(app) {
    const limit = Number(app.dataset.limit || 12);
const productHandle = app.dataset.productHandle || '';

let query = supabase
  .from('reviews')
  .select('*')
  .eq('status', 'approved')
  .order('created_at', { ascending: false })
  .limit(limit);

if (productHandle) {
  query = query.eq('product_handle', productHandle);
}

const { data: reviews, error } = await query;

    if (error) {
      app.innerHTML = '<div class="cud-public-empty">Reviews are loading soon.</div>';
      return;
    }

    if (!reviews || !reviews.length) {
      app.innerHTML = '<div class="cud-public-empty">Approved reviews will appear here soon.</div>';
      return;
    }

    const reviewIds = reviews.map(function (review) {
      return review.id;
    });

    const { data: images } = await supabase
      .from('review_images')
      .select('*')
      .in('review_id', reviewIds)
      .eq('status', 'approved')
      .eq('visible_publicly', true)
      .eq('approved_by_admin', true)
      .order('created_at', { ascending: true });

    const imagesWithUrls = await Promise.all((images || []).map(async function (img) {
  const { data, error } = await supabase.storage
    .from('review-images')
    .createSignedUrl(img.image_path, 600);

  return {
    ...img,
    display_url: !error && data ? data.signedUrl : ''
  };
}));

app.innerHTML = `
  <div class="cud-public-grid">
    ${reviews.map(function (review) {
      const reviewImages = imagesWithUrls.filter(function (img) {
        return img.review_id === review.id;
      });

      return renderReview(review, reviewImages);
    }).join('')}
  </div>
`;
  }

  function renderReview(review, images) {
    return `
      <article class="cud-public-card">
        <div class="cud-public-card-top">
          <div>
            <strong>${escapeHtml(review.first_name || 'Customer')}</strong>
            <span>${formatDate(review.created_at)}</span>
          </div>
          <div class="cud-public-stars">${'★'.repeat(review.rating || 0)}</div>
        </div>

        <p>${escapeHtml(review.review_text || '')}</p>

        ${renderImages(images)}
      </article>
    `;
  }

  function renderImages(images) {
    if (!images || !images.length) return '';

    return `
      <div class="cud-public-photos">
        ${images.map(function (img) {
          return `
            <img 
              src="${escapeHtml(img.display_url || '')}" 
              alt="${escapeHtml(img.alt_text || 'CUDOLLA customer review photo')}"
              loading="lazy">
          `;
        }).join('')}
      </div>
    `;
  }

  function formatDate(dateString) {
    if (!dateString) return '';
    return new Date(dateString).toLocaleDateString();
  }

  function escapeHtml(value) {
    return String(value || '')
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');
  }
})();